// @flow

export default class MessageBlock {
  +text: string = '';
  toString() {
    return this.text;
  }
}
